import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
/* --- Pages --- */
import LoginPage from "./pages/LoginPage";
import IntroductionPage from "./pages/private/IntroductionPage";
import OurDNAPage from "./pages/private/OurDNAPage";
import RecruitmentProcessPage from "./pages/private/RecruitmentProcessPage";
import NewExpertOrientationPage from "./pages/private/NewExpertOrientationPage";
import TrainingPage from "./pages/private/TrainingPage";
import PhilippineHolidayPage from "./pages/private/PhilippineHolidayPage";
import InformationSecurity from "./pages/private/InformationSecurity";
import OurTeamPage from "./pages/private/OurTeamPage";
import NotFoundPage from "./pages/NotFoundPage";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route element={<LoginPage />} path="/" />
        <Route element={<NotFoundPage />} path="*" />
        <Route element={<PrivateRoute />} path="/">
          <Route element={<IntroductionPage />} path="/introduction" />
          <Route element={<OurTeamPage />} path="/our-team" />
          <Route element={<OurDNAPage />} path="/our-dna" />
          <Route
            element={<RecruitmentProcessPage />}
            path="/recruitment-process"
          />
          <Route
            element={<NewExpertOrientationPage />}
            path="/new-expert-orientation"
          />
          <Route element={<TrainingPage />} path="/training" />

          <Route
            element={<InformationSecurity />}
            path="/information-security"
          />
          <Route
            element={<PhilippineHolidayPage />}
            path="/philippine-holidays"
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
